import { ChangeDetectionStrategy, Component, input, model, signal } from '@angular/core'
import { OverlayModule } from '@angular/cdk/overlay'

import { ClicksDirective } from '@shared/directives/clicks.directive'
import { IconComponent } from '../icons/icons.component'

@Component({
  selector: 'selector',
  imports: [OverlayModule, ClicksDirective, IconComponent],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectComponent<T> {
  labelClick = input<string>('')
  options = input.required<T[]>()
  optionLabel = input<string>()
  optionValue = input<string>()

  selectedOption = model.required<T>()
  isOpen = signal(false)

  select(option: T) {
    this.selectedOption.set(option)
    this.isOpen.set(false)
  }

  getValue(option: T): string {
    const optionValue = this.optionValue()

    if (!optionValue) return String(option)
    return String(option[optionValue as keyof T])
  }

  textToShow(option: T): string {
    const optionLabel = this.optionLabel()

    if (!optionLabel) return String(option)
    return String(option[optionLabel as keyof T])
  }
}
